/*------------------------------------------------
// File Name:PDM_Order.js
// File Description:PDM_Order store方法
// Author:zxl
// Create Time:2022/12/16 15:02:54
//------------------------------------------------*/

import LocalStorage from 'quasar/src/plugins/LocalStorage.js';

import {
    GetOrderListByPage,
    GetMZCFList,
    ReceivePatn,
    SendNotices
} from '@/api/pdm/recv_order'

import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmRecvOrder = {
    namespaced: true,
    state: {
        Loading: false,
        PdmOrderShowDlg: false,
        NoticeTypeOptions: [],
        //当前登录的机构ID
        HospHisCode: LocalStorage.getItem('HospHisCode')
    },
    mutations: {
        setLoading(state, data) {
            state.Loading = data
        },
        setPdmOrderShowDlg(state, visible) {
            state.PdmOrderShowDlg = visible
        },
        setCurHosp(state, curHospHisCode) {
            state.HospHisCode = curHospHisCode
            LocalStorage.set('HospHisCode', curHospHisCode)
        },
        setNoticeTypeOptions(state, data) {
            state.NoticeTypeOptions = data
        },
    },
    actions: {

        //加载用户订单主表列表
        actSetCurHosp({ commit }, parm) {
            commit('setCurHosp', parm)
        },
        //加载用户订单主表列表
        actGetOrderListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setLoading', true)
                GetOrderListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        resolve(res)
                        commit('setNoticeTypeOptions', res.OtherData.NoticeTypeOptions)
                    } else {
                        dlg.alert(res.Message)
                    }
                }).finally(() => {
                    commit('setLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //门诊处方
        actGetMZCFList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setLoading', true)
                GetMZCFList(parm).then(res => {
                    if (res.Code == 0) {
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                    }
                }).finally(() => {
                    commit('setLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //接诊
        actReceivePatn({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setLoading', true)
                ReceivePatn(parm).then(res => {
                    if (res.Code == 0) {
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                }).finally(() => {
                    commit('setLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //发通知
        actSendNotices({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setLoading', true)
                SendNotices(parm).then(res => {
                    if (res.Code == 0) {
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                }).finally(() => {
                    commit('setLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },

    }
}


